import { computed, Injectable, Signal } from '@angular/core';
import { LayoutService } from '@/layout/service/layout.service';
import { environment } from '../../environments/environment';

@Injectable({ providedIn: 'root' })
export class BackgroundTileService {
    backgroundUrl: Signal<string>;

    constructor(private layoutService: LayoutService) {
        this.backgroundUrl = computed(() => {
            if (environment.envName.toUpperCase() === 'PROD') {
                return '';
            }
            const isDark = this.layoutService.isDarkTheme();
            return this.generateTiledBackground(isDark);
        });
    }

    private generateTiledBackground(isDark: boolean): string {
        const size = 400;
        const canvas = document.createElement('canvas');
        canvas.width = size;
        canvas.height = size;
        const ctx = canvas.getContext('2d')!;

        ctx.clearRect(0, 0, size, size);
        ctx.save();
        ctx.translate(size / 2, size / 2);
        ctx.rotate((-45 * Math.PI) / 180);
        ctx.font = 'bold 100px monospace';
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        ctx.fillStyle = isDark ? 'rgba(255, 255, 255, 0.12)' : 'rgba(0, 0, 0, 0.10)';
        ctx.fillText(environment.envName, 0, 0);
        ctx.restore();

        return canvas.toDataURL('image/png');
    }
}
